// extracted by mini-css-extract-plugin
export var compact = "_n4-2";
export var phoneFrame = "_n4-0";
export var phoneScreen = "_n4-1";